import { DatePicker } from "antd";
import dayjs from "dayjs";
import styled from "styled-components";
import { InputStyled } from "./form-item-string";
import { useAdvancedFormContext } from "../advanced-form";
import { useCallback } from "react";

const DatePickerStyled = styled(DatePicker)`
  width: 100%;
`

function DatePickerWrapper({ placeholder, value, onChange, readOnly }: any) {
  if(typeof value === "string") {
    value = dayjs(value);
  } 
  
  if(value) {
    const oldValue = value;
    value = value.hour(0).minute(0).second(0).millisecond(0);
    if(oldValue.valueOf() !== value.valueOf()) {
      onChange(value)
    }
  }

  const onChangeInternal = useCallback(v => {
    onChange(v === null ? null : v.hour(0).minute(0).second(0).millisecond(0))
  }, [onChange])

  return (
    <DatePickerStyled picker="month" disabled={readOnly} placeholder={placeholder} format={'MM/YYYY'} value={value} onChange={onChangeInternal} />
  )
}

function FormItemMonth({ readOnly, disabled, label, value, onChange, typeData }: any) {
  const advancedFormContext = useAdvancedFormContext()
  const effectiveReadOnly = readOnly || advancedFormContext?.readOnly

  return (
    <>
      { effectiveReadOnly &&  <InputStyled value={value ? dayjs(value).format('MM/YYYY') : undefined} readOnly />}
      { !effectiveReadOnly && <DatePickerWrapper value={value} onChange={onChange} readOnly={readOnly} disabled={disabled} placeholder={label} picker={typeData?.picker} /> }
    </>
  )
}

export default FormItemMonth;